/** * レポートプロジェクト選択コンポーネント */
<template>
  <div class="report-project-selector">
    <b-form-select
      v-bind:value="selectedProjectId"
      v-bind:options="options"
      v-bind:disabled="disabled"
      v-on:change="changeReportProject"
      size="sm"
    ></b-form-select>
  </div>
</template>

<script>
import { RestApiClient } from 'ifield-core-components'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'

/** すべてのレポートプロジェクトID */
const ALL_PROJECTS_ID = -1

export default {
  name: 'AppReportProjectSelector',
  props: {
    /**
     * すべてのを選択している時に表示されるラベル(必須プロパティ)
     */
    selectedAllLabel: {
      type: String,
      required: true,
    },

    /**
     * 選択しているプロジェクトID
     */
    selectedProjectId: {
      type: Number,
      default: ALL_PROJECTS_ID,
    },

    /**
     * すべての...アイテムを末尾に表示するフラグ
     */
    selectedAllItemToTail: {
      type: Boolean,
      default: false,
    },

    /**
     * 選択リストの先頭のアイテムを選択させる処理を行うか否かのフラグ
     */
    selectFirstItemOnMounted: {
      type: Boolean,
      default: false,
    },

    /**
     * 自分の担当プロジェクトのみ利用可能にするか否かのフラグ
     */
    onlyMyProject: {
      type: Boolean,
      default: true,
    },

    /**
     * 無効化フラグ
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, context) {
    const { handleApiError } = useHandleApiError(props, context)
    return { handleApiError }
  },

  data: function () {
    return {
      options: [],
    }
  },

  computed: {
    /**
     * 報告書プロジェクト取得リソースURL
     * @type {String}
     */
    reportProjectUrl: function () {
      return this.onlyMyProject ? 'report_project/myaccount' : 'report_project'
    },
  },

  mounted: function () {
    let optionsPromise = this.$_setOptions()
    // 先頭項目選択フラグが有効な場合、選択リスト作成後
    // 先頭の値で上書き
    if (this.selectFirstItemOnMounted) {
      optionsPromise.then(() => {
        if (this.options.length) {
          this.changeReportProject(this.options[0].value)
        }
      })
    }
  },

  methods: {
    /**
     * グループが選択された時の処理
     */
    changeReportProject: function (newProjectId) {
      this.$emit('change-report-project', newProjectId)
    },

    /**
     * 報告書プロジェクトの一覧を取得し、選択リストに設定する
     */
    $_setOptions: function () {
      return RestApiClient.executeGetApi(
        RestApiClient.createApiUrl(this.reportProjectUrl)
      )
        .then((json) => {
          // すべての...アイテム
          let allProjectItem = {
            value: ALL_PROJECTS_ID,
            text: this.selectedAllLabel,
          }
          this.options = []
          for (var project of json.data) {
            this.options.push({
              value: project.id,
              text: project.report_project_name,
            })
          }
          // すべての...アイテム追加処理
          if (this.selectedAllItemToTail) {
            this.options.push(allProjectItem)
          } else {
            this.options.splice(0, 0, allProjectItem)
          }
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    },
  },
}
</script>
